import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import { cloneElement, createElement, forwardRef, isValidElement } from 'react';
import { useDefaultComponentValue } from '../../../utils/useDefaultComponentValue';
const COMPONENT_NAME = 'ListBoxItem';
const defaultContainer = 'li';
const ListBoxItem = /*#__PURE__*/ forwardRef((inProps, ref)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { children, className, link, isSelectOption, containerElement = defaultContainer, onClick, ...other } = props;
    let itemElement;
    const classNames = cx('List-item', className, {
        Link: link
    });
    if (link || onClick && containerElement === defaultContainer && !isSelectOption) {
        const aProps = {
            href: link || undefined,
            className: classNames,
            onClick: (e)=>{
                if (onClick) {
                    e.preventDefault();
                    onClick(e);
                }
            },
            ref,
            ...other
        };
        itemElement = /*#__PURE__*/ createElement('a', aProps, children);
    } else {
        const elementProps = {
            className: classNames,
            onClick,
            ref,
            ...other
        };
        if (/*#__PURE__*/ isValidElement(containerElement)) {
            itemElement = /*#__PURE__*/ cloneElement(containerElement, elementProps, children);
        } else {
            itemElement = /*#__PURE__*/ createElement(containerElement, elementProps, children);
        }
    }
    return itemElement;
});
ListBoxItem.displayName = COMPONENT_NAME;
ListBoxItem.propTypes = {
    /**
	 * Children will be rendered within the `ListBox`.
	 */ children: PropTypes.node,
    /**
	 * Custom `className` for the root.
	 */ className: PropTypes.string,
    /**
	 * Specifies container element could be 'div' or 'span'. Should be passed from parent component.
	 */ containerElement: PropTypes.node,
    /**
	 * True, if this component is a child of Select component
	 * (it will not be rendered as <a> element)
	 */ isSelectOption: PropTypes.bool,
    /**
	 * If specified the node will be <a> element with href attribute.
	 */ link: PropTypes.string,
    /**
	 * On click action for the list item
	 */ onClick: PropTypes.func
};
export default ListBoxItem;
